import {IUserApi} from '../../api/user-api.service';

export interface IOrganizationService {
	getCurrentOrgId():ng.IPromise<number>;
}

export default class OrganizationService implements IOrganizationService{
  static $inject = ['$window', 'userApi', '$q'];

  constructor(
  	private $window: ng.IWindowService,
  	private userApi: IUserApi,
  	private $q:ng.IQService
  ) {
  	
  }

  getCurrentOrgId() {
  	const deferred = this.$q.defer<number>();
  	let currentOrgId: string = this.$window.localStorage
            .getItem('currentOrgId');

    if (currentOrgId) {
      deferred.resolve(parseInt(currentOrgId, 10));
    } else {
      this.userApi.getCurrentUser()
        .then(data => {
           deferred.resolve(parseInt(data.sourceId,10));
           this.$window.localStorage.setItem('currentOrgId', data.sourceId);
         }, errorData => {
         	deferred.reject();
         });
    }

    return deferred.promise;
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/organization/organization.service.ts
 **/